// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    label: "True",
    value: true,
  },
  {
    label: "False",
    value: false,
  },
];
